var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row" },
    [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" },
        [
          _c(
            "c-table",
            {
              ref: "grid",
              attrs: {
                title: "수질오염방지시설 고장 유무 및 특기사항",
                tableId: "grid",
                columns: _vm.grid.columns,
                gridHeightAuto: "",
                data: _vm.grid.data,
                usePaging: false,
                hideBottom: false,
                columnSetting: false,
                filtering: false,
                isExcelDown: false,
                editable: _vm.editable,
                selection: "multiple",
                rowKey: "envWaterMstPreventiveBreakdownId",
              },
            },
            [
              _c(
                "template",
                { slot: "table-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      !_vm.param.isFullScreen && _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "추가", icon: "add" },
                            on: { btnClicked: _vm.addPreventive },
                          })
                        : _vm._e(),
                      !_vm.param.isFullScreen && _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "삭제", icon: "remove" },
                            on: { btnClicked: _vm.removePreventive },
                          })
                        : _vm._e(),
                      !_vm.param.isFullScreen && _vm.editable
                        ? _c("c-btn", {
                            attrs: { label: "저장", icon: "save" },
                            on: { btnClicked: _vm.saveData },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }